/**
 * GENERATED FILE - DO NOT EDIT
 * This file was automatically generated by the genPluralCategories.js script.
 * It contains the plural categories for each language as defined in the
 * CLDR data. The data is used by the iLib library to determine which plural
 * category to use for a given language and number.
 *
 * @license Apache-2.0
 */
const pluralCategories ={
    "ar": [
        "zero",
        "one",
        "two",
        "few",
        "many",
        "other"
    ],
    "ars": [
        "zero",
        "one",
        "two",
        "few",
        "many",
        "other"
    ],
    "be": [
        "one",
        "few",
        "many",
        "other"
    ],
    "blo": [
        "zero",
        "one",
        "other"
    ],
    "bm": [
        "other"
    ],
    "bo": [
        "other"
    ],
    "br": [
        "one",
        "two",
        "few",
        "many",
        "other"
    ],
    "bs": [
        "one",
        "few",
        "other"
    ],
    "ca": [
        "one",
        "many",
        "other"
    ],
    "cs": [
        "one",
        "few",
        "many",
        "other"
    ],
    "cy": [
        "zero",
        "one",
        "two",
        "few",
        "many",
        "other"
    ],
    "dsb": [
        "one",
        "two",
        "few",
        "other"
    ],
    "dz": [
        "other"
    ],
    "es": [
        "one",
        "many",
        "other"
    ],
    "fr": [
        "one",
        "many",
        "other"
    ],
    "ga": [
        "one",
        "two",
        "few",
        "many",
        "other"
    ],
    "gd": [
        "one",
        "two",
        "few",
        "other"
    ],
    "gv": [
        "one",
        "two",
        "few",
        "many",
        "other"
    ],
    "he": [
        "one",
        "two",
        "other"
    ],
    "hnj": [
        "other"
    ],
    "hr": [
        "one",
        "few",
        "other"
    ],
    "hsb": [
        "one",
        "two",
        "few",
        "other"
    ],
    "id": [
        "other"
    ],
    "ig": [
        "other"
    ],
    "ii": [
        "other"
    ],
    "it": [
        "one",
        "many",
        "other"
    ],
    "iu": [
        "one",
        "two",
        "other"
    ],
    "ja": [
        "other"
    ],
    "jbo": [
        "other"
    ],
    "jv": [
        "other"
    ],
    "jw": [
        "other"
    ],
    "kde": [
        "other"
    ],
    "kea": [
        "other"
    ],
    "km": [
        "other"
    ],
    "ko": [
        "other"
    ],
    "ksh": [
        "zero",
        "one",
        "other"
    ],
    "kw": [
        "zero",
        "one",
        "two",
        "few",
        "many",
        "other"
    ],
    "lag": [
        "zero",
        "one",
        "other"
    ],
    "lkt": [
        "other"
    ],
    "lld": [
        "one",
        "many",
        "other"
    ],
    "lo": [
        "other"
    ],
    "lt": [
        "one",
        "few",
        "many",
        "other"
    ],
    "lv": [
        "zero",
        "one",
        "other"
    ],
    "mo": [
        "one",
        "few",
        "other"
    ],
    "ms": [
        "other"
    ],
    "mt": [
        "one",
        "two",
        "few",
        "many",
        "other"
    ],
    "my": [
        "other"
    ],
    "naq": [
        "one",
        "two",
        "other"
    ],
    "nqo": [
        "other"
    ],
    "osa": [
        "other"
    ],
    "pl": [
        "one",
        "few",
        "many",
        "other"
    ],
    "prg": [
        "zero",
        "one",
        "other"
    ],
    "pt": [
        "one",
        "many",
        "other"
    ],
    "pt-PT": [
        "one",
        "many",
        "other"
    ],
    "ro": [
        "one",
        "few",
        "other"
    ],
    "ru": [
        "one",
        "few",
        "many",
        "other"
    ],
    "sah": [
        "other"
    ],
    "sat": [
        "one",
        "two",
        "other"
    ],
    "scn": [
        "one",
        "many",
        "other"
    ],
    "se": [
        "one",
        "two",
        "other"
    ],
    "ses": [
        "other"
    ],
    "sg": [
        "other"
    ],
    "sh": [
        "one",
        "few",
        "other"
    ],
    "shi": [
        "one",
        "few",
        "other"
    ],
    "sk": [
        "one",
        "few",
        "many",
        "other"
    ],
    "sl": [
        "one",
        "two",
        "few",
        "other"
    ],
    "sma": [
        "one",
        "two",
        "other"
    ],
    "smi": [
        "one",
        "two",
        "other"
    ],
    "smj": [
        "one",
        "two",
        "other"
    ],
    "smn": [
        "one",
        "two",
        "other"
    ],
    "sms": [
        "one",
        "two",
        "other"
    ],
    "sr": [
        "one",
        "few",
        "other"
    ],
    "su": [
        "other"
    ],
    "th": [
        "other"
    ],
    "to": [
        "other"
    ],
    "tpi": [
        "other"
    ],
    "uk": [
        "one",
        "few",
        "many",
        "other"
    ],
    "und": [
        "other"
    ],
    "vec": [
        "one",
        "many",
        "other"
    ],
    "vi": [
        "other"
    ],
    "wo": [
        "other"
    ],
    "yo": [
        "other"
    ],
    "yue": [
        "other"
    ],
    "zh": [
        "other"
    ]
};
export default pluralCategories;